import { LargeSectionHeader, ShortBody } from 'components/Typography';
import styled from 'styled-components';
import breakpoints from 'utils/breakpoints';

export const StyledLargeSectionHeader = styled(LargeSectionHeader)`
  &&& {
    @media (max-width: ${breakpoints.xs}) {
      font-size: 21px;
    }
  }
`;
export const StyledShortBody = styled(ShortBody)`
  &&& {
    @media (max-width: ${breakpoints.xs}) {
      font-size: 12px;
    }
  }
`;
